import { render } from "./ProjectView.vue?vue&type=template&id=3e99fe14"
import script from "./ProjectView.vue?vue&type=script&lang=js"
export * from "./ProjectView.vue?vue&type=script&lang=js"

import "./ProjectView.vue?vue&type=style&index=0&id=3e99fe14&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProjectView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e99fe14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e99fe14', __exports__)) {
    api.reload('3e99fe14', __exports__)
  }
  
  module.hot.accept("./ProjectView.vue?vue&type=template&id=3e99fe14", () => {
    api.rerender('3e99fe14', render)
  })

}


export default __exports__